@let disabled = disabled$ | async;
@let hasRequired = control | controlHasRequired;
<app-control-wrapper
  [control]="control"
  [officeField]="officeField"
  [formGroupInstance]="formGroupInstance"
  [errorsMessagesOverridesRegistry]="errorsMessagesOverridesRegistry"
  [required]="control | controlHasRequired"
  [validating]="validating$()"
  [disabled]="disabled || validating$()"
  [alignment]="alignment"
  [config]="config">
  <select
    class="form-control"
    [formControl]="control"
    [name]="officeField.VistaFormItem.ColumnName ? '' : null"
    [attr.disabled]="disabled ? '' : null">
    <option
      *ngIf="(!hasRequired && officeField.VistaFormItem.ControlType !== controlTypeEnum.RadioButtons) || (hasRequired && !control.value)"
      [value]=""></option>
    <option *ngFor="let item of comboBoxItems" [value]="item.DatabaseValue">
      {{ item.DisplayValue }}
    </option>
  </select>
</app-control-wrapper>
